module.exports = __webpack_public_path__ + "img/sup_kyc_3.6a7e0666.jpg";